// extracted by mini-css-extract-plugin
export default {"featuresGrid":"eIKXgIbCEpiCzAcltsl6","featureItem":"nf7Y4F0b8PSARtkt7t1B","featureText":"y5aRrV6YyAs6hUi3fzq8","title":"Yf6Z9FpPFnHK8yji0JlR","description":"_yBHSzDNdMHHYhImQiDX"};